import React from 'react';
import { Tooltip } from 'primereact/tooltip';
import { DataTooltipProps } from '@/types';
import classNames from 'classnames';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

const DataTooltip: React.FC<DataTooltipProps> = (data) => {
  const contentClasses = classNames('grid grid-cols-12 gap-4');
  const descriptionClasses = classNames('text-tooltip text-justify', {
    'col-span-12': !data.images,
    'col-span-8': data.images
  });

  return (
    <Tooltip
      mouseTrack
      data-testid="tooltip"
      target={data.anchor}
      className="p-4 bg-white border-[4px] border-primary rounded-[1.25rem] max-w-[25rem] min-h-[16.75rem]"
    >
      <h4
        data-test-id="data-tooltip__title"
        className="text-label font-bold mb-4"
      >
        {data.title}
      </h4>
      <div className={contentClasses}>
        <p
          data-test-id="data-tooltip__description"
          className={descriptionClasses}
        >
          {data.description}
        </p>
        {data.images && (
          <div className="col-span-4 flex flex-col justify-center">
            {data.images.map((image) => (
              <GatsbyImage
                key={data.title}
                image={getImage(image)}
                alt={data.title}
                className="w-full object-contain"
              />
            ))}
          </div>
        )}
      </div>
    </Tooltip>
  );
};

export default DataTooltip;
